"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShaderSrc = exports.fetch = void 0;
function fetch(filepath) {
    var request = new XMLHttpRequest();
    request.open('GET', filepath, false);
    request.send();
    return request.responseText;
}
exports.fetch = fetch;
;
var ShaderSrc = (function () {
    function ShaderSrc(vert, frag) {
        this.vert = vert;
        this.frag = frag;
    }
    ShaderSrc.prototype.batchReplace = function (includes) {
        for (var _i = 0, includes_1 = includes; _i < includes_1.length; _i++) {
            var include = includes_1[_i];
            this.vert = this.vert.replace(new RegExp(include.toReplace), include.replacement);
            this.frag = this.frag.replace(new RegExp(include.toReplace), include.replacement);
        }
    };
    ShaderSrc.fromScript = function (vertId, fragId) {
        var vert = document.getElementById(vertId).text;
        var frag = document.getElementById(fragId).text;
        return new ShaderSrc(vert, frag);
    };
    return ShaderSrc;
}());
exports.ShaderSrc = ShaderSrc;
